import {
  LoggedInUserInfoDTO,
} from '@/dtos';
import {
  setAuthHeaders,
} from './httpClient';
export interface AuthUser {
  id: string;
  phoneNumber: string;
  name?: string;
  email?: string;
}

export type AuthState = {
  user: LoggedInUserInfoDTO | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

export const logout = async (): Promise<void> => {
  // Clear all local storage items that might contain auth data
  if (typeof window !== 'undefined') {
    setAuthHeaders();
    clearStoredAuth();
  }
};

// Local storage helpers
export const getAuthToken = (): string | null => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('auth_token');
};

export const setAuthToken = (token: string): void => {
  if (typeof window === 'undefined') return;
  localStorage.setItem('auth_token', token);
};

export const setStoredAuth = (token: string): void => {
  setAuthToken(token);
};

export const clearStoredAuth = (): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('patientOrgMappings');
    localStorage.removeItem('signalr_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('session_hash');
  }
};
export const removeSignalRToken = (): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('signalr_token');
  }
};